import { useEffect } from 'react';

/**
 * ImageProtection Component
 * Wraps images with protection against right-click, drag, and download
 */
export function ProtectedImage({ src, alt, className = '', ...props }) {
  return (
    <div 
      className="image-protection-wrapper"
      onContextMenu={(e) => e.preventDefault()}
    >
      <img
        src={src}
        alt={alt}
        className={`protected-image ${className}`}
        draggable={false}
        onDragStart={(e) => e.preventDefault()}
        {...props}
      />
    </div>
  );
}

/**
 * Hook to apply global image protection
 * Prevents right-click on images and disables dev tools shortcuts
 */
export function useImageProtection() {
  useEffect(() => {
    // Prevent right-click on images
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    // Prevent dragging images
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    // Prevent keyboard shortcuts for saving/inspecting
    const handleKeyDown = (e) => {
      // Prevent Ctrl+S (save page)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
      }
      // Prevent Ctrl+U (view source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
      }
      // Prevent F12 (dev tools) - optional, can be intrusive
      // if (e.key === 'F12') {
      //   e.preventDefault();
      // }
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
}

/**
 * Global Image Protection Provider
 * Add this to App.js to enable protection across the entire app
 */
export function ImageProtectionProvider({ children }) {
  useImageProtection();
  return children;
}

export default ProtectedImage;
